function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var antPrefixCls = '.ant-radio';
var getRadioBasicStyle = function getRadioBasicStyle(token) {
  var _hover, _ref, _ref2, _ref3, _ref4;
  var radioInnerPrefixCls = antPrefixCls + "-inner";
  return _ref4 = {}, _ref4[antPrefixCls + "-wrapper"] = (_ref3 = {
    marginInlineEnd: 16,
    '&:hover': (_hover = {}, _hover[antPrefixCls + ":not(" + antPrefixCls + "-checked):not(" + antPrefixCls + "-disabled)"] = {
      '.ant-radio-inner': {
        borderColor: token.colorTextSecondary
      }
    }, _hover)
  }, _ref3[antPrefixCls + "-disabled"] = (_ref2 = {}, _ref2[antPrefixCls + "-inner"] = {
    borderColor: token.colorBorderSecondary
  }, _ref2["&" + antPrefixCls + "-checked"] = (_ref = {}, _ref[radioInnerPrefixCls] = {
    borderColor: token.colorPrimaryBgDisabled,
    backgroundColor: token.colorPrimaryBgDisabled,
    '&::after': {
      background: token.colorBgLayout,
      transform: 'scale(0.375)'
    }
  }, _ref), _ref2), _ref3), _ref4;
};
var getRadioButtonStyle = function getRadioButtonStyle(token) {
  var _checked, _ref5, _ref6, _ref7, _ref8, _ref9;
  return _ref9 = {}, _ref9[antPrefixCls + "-group"] = (_ref6 = {}, _ref6[antPrefixCls + "-button-wrapper"] = (_ref5 = {
    //选中未禁用
    paddingInline: 16
  }, _ref5['&-checked:not(&-disabled)'] = {
    color: token.colorPrimary,
    borderColor: token.colorPrimary
  }, _ref5['&-checked'] = (_checked = {}, _checked["+" + antPrefixCls + "-button-wrapper"] = {
    '&::before': {
      backgroundColor: token.colorPrimaryBgDisabled
    }
  }, _checked), _ref5["&:not(&-checked):not(&-disabled)"] = {
    color: token.colorTextSecondary,
    '&:hover': {
      color: token.colorInfoTextActive
    }
  }, _ref5), _ref6["&-small " + antPrefixCls + "-button-wrapper"] = {
    paddingInline: 12
  }, _ref6["&-large " + antPrefixCls + "-button-wrapper"] = {
    paddingInline: 20
  }, _ref6['.ant-radio-button-wrapper-disabled'] = {
    borderColor: token.colorBorderSecondary
  }, _ref6), _ref9[antPrefixCls + "-group-solid"] = (_ref8 = {
    padding: 2,
    background: token.colorFillTertiary,
    borderRadius: token.borderRadius
  }, _ref8[antPrefixCls + "-button-wrapper"] = (_ref7 = {
    borderColor: 'transparent',
    borderRadius: token.borderRadius
  }, _ref7["+" + antPrefixCls + "-button-wrapper::before"] = {
    backgroundColor: 'transparent !important'
  }, _ref7['&-checked:not(&-disabled)'] = {
    background: token.colorBgContainer,
    borderColor: token.colorFillTertiary,
    borderRadius: token.borderRadius
  }, _ref7["&:not(&-checked):not(&-disabled)"] = {
    color: token.colorTextTertiary,
    background: token.colorFillTertiary
  }, _ref7), _ref8), _ref9;
};
var radioStyleFn = function radioStyleFn(token) {
  var fontSizeLG = token.fontSizeLG,
    lineWidth = token.lineWidth;
  var radioSize = fontSizeLG;
  var dotPadding = 4;
  var radioDotSize = radioSize - (dotPadding + lineWidth) * 2;
  var radioDotDisabledSize = radioDotSize;
  var radioToken = _extends({}, token, {
    radioSize: radioSize,
    radioDotDisabledSize: radioDotDisabledSize
  });
  return [getRadioBasicStyle(radioToken), getRadioButtonStyle(radioToken)];
};

export { radioStyleFn };
